import { IPluginProvider } from './IPluginProvider';

export module PluginLocator {
  export let instance: IPluginProvider;
}